import { AuditAudio } from '@mi-front/core';
import PlayCircleOutlineRoundedIcon from '@mui/icons-material/PlayCircleOutlineRounded';
import React from 'react';
import { useIntl } from 'react-intl';
import { RowActionMui, RowActionMuiProps } from '../../../../../components/table/RowActionMui';
import { useUrlMediaPlayerCtx } from '../../../../../core/media-player/useUrlMediaPlayer';
import { mimeType } from '../../../../../helpers/utils';
import {
  buildAuditMediaFileUrl,
  resolveAuditMediaIdByCustomId,
} from '../helpers/build-audit-media-file-url';

export function AuditMediaPlayerAction({
  audio,
  ActionComponent = RowActionMui,
}: {
  audio: Pick<AuditAudio, 'stationId' | 'customId' | 'filename'> & { id?: string };
  ActionComponent?: React.ComponentType<RowActionMuiProps>;
}) {
  const ctx = useUrlMediaPlayerCtx();
  const { $t } = useIntl();

  return (
    <ActionComponent
      title={$t({
        id: 'audit.mediaPlayer.viewMedia',
        defaultMessage: 'Reproducir media',
      })}
      color="primary"
      onClick={async () => {
        const mediaId =
          audio.id ??
          (audio.stationId
            ? await resolveAuditMediaIdByCustomId(audio.stationId, audio.customId)
            : null);

        if (!mediaId) {
          return;
        }

        ctx.play(buildAuditMediaFileUrl(mediaId), {
          title: audio.customId,
          type: mimeType(audio.filename),
        });
      }}
    >
      <PlayCircleOutlineRoundedIcon />
    </ActionComponent>
  );
}
